import React from 'react';
import CrudTable, { ImageCell } from '../../components/admin/CrudTable';

export default function ManageDoctors() {
  return (
    <CrudTable
      entity="doctors"
      title="Həkimlər"
      defaults={{ name: '', specialty: '', education: '', diseases: '', image: '', order: 0 }}
      fields={[
        { key: 'name', label: 'Ad Soyad', type: 'text' },
        { key: 'specialty', label: 'İxtisas', type: 'text' },
        { key: 'education', label: 'Təhsil', type: 'textarea', rows: 8 },
        { key: 'diseases', label: 'Müalicə etdiyi xəstəliklər', type: 'textarea', rows: 8 },
        { key: 'image', label: 'Səkil', type: 'image' },
        { key: 'order', label: 'Sıra', type: 'number' },
      ]}
      listColumns={[
        { key: 'image', label: 'Səkil', render: ImageCell },
        { key: 'name', label: 'Ad Soyad' },
        { key: 'specialty', label: 'İxtisas' },
        { key: 'order', label: 'Sıra' },
      ]}
    />
  );
}
